import { render } from "./HomeComp.vue?vue&type=template&id=4a3af992&scoped=true"
import script from "./HomeComp.vue?vue&type=script&lang=js"
export * from "./HomeComp.vue?vue&type=script&lang=js"

import "./HomeComp.vue?vue&type=style&index=0&id=4a3af992&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3af992"]])

export default __exports__